import './App.css';
import { Outlet,Link } from 'react-router-dom';
import NavbarMain from './components/NavbarMain';
import { Container, Row, Col} from 'react-bootstrap'
import { host as host_api } from './axiosInterceptor'


function App() {

  const host = process.env.REACT_APP_URL_APP;

  return (<>
   <Container fluid>
    <Row>
      <Col>
        <NavbarMain/>
      </Col>
    </Row>

    <Row>
      <Col className='p-0' style={{marginTop:"81px"}}>
        <Outlet />
      </Col>
    </Row>

    <footer className='bg-light shadow-sm mt-2 pt-5'>
      <Container fluid>
      <Row className='justify-content-center border-bottom'>
      <Col xs='6' sm='4' md='3' lg='2' xxl='3' className='mb-2'>

        <img src={`${host}/logo.png`} style={{width:"150px"}} className='d-table ms-auto me-auto' alt='CEDIJ'/>
        <h6 className='text-center'>Centro de Documentación</h6>
        
        <Link to={'/login'} className='d-table pb-1 link-secondary link-underline-opacity-0 float-start' style={{fontSize:"13px"}}>Iniciar Sesión</Link>
        <Link to={'/register'} className='d-table pb-1 link-secondary link-underline-opacity-0 float-end'style={{fontSize:"13px"}}>Registrase</Link>
        
       
        </Col>

        <Col xs='8' sm='4' md='4' lg='3' xxl='2' className='mb-2'>
        <h5>Nuevos Servicios</h5>
        <Link to={'/search_of_resolved_judgments'} className='d-table p-1 link-secondary link-underline-opacity-0' style={{fontSize:"13px"}}>Buscador Juridico Documental</Link>
        <Link to={'/history_of_resolved_judgments'} className='d-table p-1 link-secondary link-underline-opacity-0' style={{fontSize:"13px"}}>Sentencias Historicas</Link>
        <Link to={'/digital_publications/Boletines-Judiciales/1'} className='d-table p-1 link-secondary link-underline-opacity-0' style={{fontSize:"13px"}}>Publicaciones Digitales</Link>
        
        </Col>

        <Col xs='8' sm='4' md='4' lg='3' xxl='2' className='mb-2'>
        <h5>Marco Legal</h5>
        <Link to={`${host_api}/assets/documents/agreement/AcuerdoNo305.pdf`} target='_blank' className='d-table p-1 link-secondary link-underline-opacity-0' style={{fontSize:"13px"}}>Acuerdo No. 305 - 2015</Link>
        <Link to={`${host_api}/assets/documents/agreement/AcuerdoNo.033-2003.pdf`} target='_blank' className='d-table p-1 link-secondary link-underline-opacity-0 text-center' style={{fontSize:"13px"}}> Acuerdo No. 33 - 2003</Link>
        <Link to={`${host_api}/assets/documents/agreement/AcuerdoNo306.pdf`} target='_blank' className='d-table p-1 link-secondary link-underline-opacity-0 text-center' style={{fontSize:"13px"}}>Acuerdo No. 306 - 2015</Link>
        </Col>

        <Col xs='8' sm='12' md='12' lg='4' xxl='5' className='mb-2'>
  
        <Row>
          <Col sm='4' md='4' lg='6' xxl='6' className='mb-2'>
          <h5>Acerca de Nosotros</h5>
          <Link to={'/mission'} className='d-table p-1 link-secondary link-underline-opacity-0' style={{fontSize:"13px"}}>Misión, Visión, Objectivos y Politicas</Link>
        
          </Col>

          <Col sm='4' md='4' lg='6' xxl='6' className='mb-2'>
          <h5>Contáctenos</h5>
          <p className='d-table p-1 link-secondary link-underline-opacity-0 m-0' style={{fontSize:"13px"}}>Correo: info.cedij@poderjudicial.gob.ni</p>
          <p className='d-table p-1 link-secondary link-underline-opacity-0 m-0' style={{fontSize:"13px"}}>Teléfono: +(505) 22330575</p>
        
          </Col>
        </Row>
       

       </Col>

       

      </Row>

      <Row>
        <Col>
        <p className='p-2 text-center'>© 2024 CEDIJ, Todos los derechos reservados</p>
        </Col>
      </Row>
      </Container>
      
    </footer>
   </Container>
  
   </>);

}

export default App;
